/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TeamAssignment } from '../models/TeamAssignment';
import type { TeamAssignments } from '../models/TeamAssignments';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TeamAssignmentsService {
    /**
     * create team assignment
     * @param tenantId tenant_id
     * @param constructionSiteId construction_site_id
     * @param requestBody
     * @returns TeamAssignment team assignment created
     * @throws ApiError
     */
    public static createTeamAssignment(
        tenantId: string,
        constructionSiteId: string,
        requestBody?: TeamAssignment,
    ): CancelablePromise<TeamAssignment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/construction_sites/{construction_site_id}/team_assignments',
            path: {
                'tenant_id': tenantId,
                'construction_site_id': constructionSiteId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `invalid request`,
            },
        });
    }
    /**
     * list team_assignments
     * @param tenantId tenant_id
     * @param startDate
     * @param endDate
     * @returns TeamAssignments successful
     * @throws ApiError
     */
    public static getTeamAssignments(
        tenantId: string,
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<TeamAssignments> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/team_assignments',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
        });
    }
    /**
     * update team assignment
     * @param tenantId tenant_id
     * @param id id
     * @param requestBody
     * @returns TeamAssignment team assignment updated
     * @throws ApiError
     */
    public static updateTeamAssignment(
        tenantId: string,
        id: string,
        requestBody?: TeamAssignment,
    ): CancelablePromise<TeamAssignment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tenants/{tenant_id}/team_assignments/{id}',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `invalid request`,
            },
        });
    }
    /**
     * delete team assignment
     * @param tenantId tenant_id
     * @param id id
     * @returns void
     * @throws ApiError
     */
    public static deleteTeamAssignment(
        tenantId: string,
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tenants/{tenant_id}/team_assignments/{id}',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
        });
    }
}
